<div class="modal-header">
    <h4 class="modal-title"> {{'copyProjectPopup.title' | translate}} </h4>
</div>
<div class="modal-body pt-0">
    <div class="modal-body-inner">
        <p>{{'copyProjectPopup.label' | translate}}</p>
        <div class="ps-5">
            <div *ngIf="isCopyProjectPropertiesAvailable()" class="form-check mb-2">
                <input class="form-check-input" type="checkbox" id="copyProjectProperties" [(ngModel)]="copyProjectProperties">
                <label data-testid="apply-data-project-properties" class="form-check-label" for="copyProjectProperties">{{'copyProjectPopup.input.copyProjectProperties' | translate}}</label>
            </div>
            <div *ngIf="isCopyConfigurationPropertiesAvailable()" class="form-check mb-2">
                <input class="form-check-input" type="checkbox" id="copyConfigurationProperties" [(ngModel)]="copyConfigurationProperties">
                <label data-testid="apply-data-configuration-properties" class="form-check-label" for="copyConfigurationProperties">{{'copyProjectPopup.input.copyConfigurationProperties' | translate}}</label>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-cancel" (click)="cancel()">{{'global.label.cancel' | translate}}</button>
    <button type="button" data-testid="apply-data-ok" class="btn btn-primary btn-forward" (click)="apply()">{{'global.label.ok' | translate}}</button>
</div>
